// ============================================
// CONEXIONSTATUS.JS — Indicador de estado de conexión
// ============================================

import React, { useState, useEffect } from 'react';

const PP = "'Poppins', sans-serif";

function ConexionStatus() {
  const [enLinea, setEnLinea] = useState(navigator.onLine);
  const [mostrarRestaurada, setMostrarRestaurada] = useState(false);
  const [primeraVez, setPrimeraVez] = useState(true);

  useEffect(() => {
    const handleOnline = () => {
      setEnLinea(true);
      if (!primeraVez) {
        setMostrarRestaurada(true);
        setTimeout(() => setMostrarRestaurada(false), 3000);
      }
    };
    const handleOffline = () => {
      setEnLinea(false);
      setPrimeraVez(false);
    };
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    // Marcar que ya pasó la carga inicial
    const t = setTimeout(() => setPrimeraVez(false), 1000);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      clearTimeout(t);
    };
  }, [primeraVez]);

  // No mostrar nada si estamos en línea y no hay mensaje de restauración
  if (enLinea && !mostrarRestaurada) return null;

  return (
    <div style={{
      padding: '8px 16px',
      textAlign: 'center',
      fontSize: '12px',
      fontWeight: '600',
      fontFamily: PP,
      transition: 'all 0.3s ease',
      background: enLinea ? '#e8faf5' : '#fff0f0',
      color: enLinea ? '#1D9E75' : '#e05c5c',
      borderBottom: enLinea ? '1px solid #5cd4b0' : '1px solid #e05c5c',
    }}>
      {enLinea
        ? 'Conexión restaurada — sincronizando...'
        : 'Sin conexión — trabajando sin internet'
      }
    </div>
  );
}

export default ConexionStatus;
